import { Component, HostBinding, OnDestroy, ChangeDetectorRef, OnInit, AfterViewInit, QueryList, ViewChildren, } from '@angular/core';
import { Observable } from 'rxjs';
import { CmsService } from '../../core/services/cms.service';
import { LogCategory, LoggerService, LogType, LogWidget } from '../../core/services/logger.service';
import { ProfileService } from '../../core/services/profile.service';
import { TagManagerService } from '../../core/services/tag-manager.service';
import { ProfileSetting } from '../../pages/profile/profile.component';
import { IWidgetComponent } from '../../shared/widget/i-widget-component';
import { Widget } from '../../shared/widget/widget';
import { NgbdSortableHeaderDirective, SortEvent } from '../../directives/table-column-sortable.directive';
import { LoadingWrapper } from '../../shared/loadingwrapper';

@Component({
    selector: 'app-my-pages',
    templateUrl: './my-pages.component.html',
    styleUrls: ['./my-pages.component.scss'],
    standalone: false
})
export class MyPagesComponent implements OnInit, OnDestroy, AfterViewInit, IWidgetComponent {
    public data: Widget;
    public isActive: boolean = false;
    public tags: string[] = [];
    pages;
    filterText: '';
    

    //public cmsContent;
    @ViewChildren(NgbdSortableHeaderDirective) headers: QueryList<NgbdSortableHeaderDirective>;

    @HostBinding('class')
    get size(): string {
        return 'col-md-' + this.data.Size.toString();
    }

    constructor(
        private logger: LoggerService,
        public cms: CmsService,
        private gtm: TagManagerService,
        private changeDetector: ChangeDetectorRef,
        public profileService: ProfileService
    ) {
        this.log("constructor", null, LogCategory.Constructor);
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Widget, LogWidget.MyLinks, category);
    }

    ngOnInit() {
        this.log("ngOnInit", null, LogCategory.Init);
        this.pages = new LoadingWrapper(this.cms.getV2ContentByType$("TilePages"));

    }

    ngOnDestroy() {
        this.log("ngOnDestroy", "", LogCategory.Destroy);
    }

    ngAfterViewInit() {
        // See https://blog.angularindepth.com/everything-you-need-to-know-about-the-expressionchangedafterithasbeencheckederror-error-e3fd9ce7dbb4
        // Added after error handling template added to component.
        this.changeDetector.detectChanges();
    }

    //public updateFavorite(favorites, item) {


    //    //  Update the local variable so we don't have to re-fetch the whole profile
    //    //  after updating.
    //    const index = favorites.indexOf(item.Id);
    //    let isFave = true;
    //    if (index > -1) {
    //        favorites.splice(index, 1);
    //        isFave = false;
    //    }
    //    else
    //        favorites.push(item.Id);

    //    //We are recording favorites to google analytics
    //    this.gtm.gaLinkFave(this.profileService.labelLookup[this.data.meta.Name], item.Title, isFave);


    //    var data: ProfileSetting[] = [new ProfileSetting()]
    //    data[0].Id = ".Myke.Favorites";
    //    data[0].Type = "text";
    //    data[0].Value = item.Id;
    //    this.profileService.updateSettings(data, false);
    //}

    public linkClicked(item) {
        this.gtm.gaLinkClicked(this.profileService.labelLookup[this.data.meta.Name], item.Title);
        console.log("Name", this.data.meta.Name);
        console.log("GA Link Clicked", this.profileService.labelLookup[this.data.meta.Name]);
    }

    onSort({ column }: SortEvent) {

        // resetting other headers
        this.headers.forEach(header => {
            if (header.sortable !== column) {
                header.direction = '';
            }
        });
    }
}

